import React, { useRef, useEffect, useState  } from "react";
import jsPDF from "jspdf";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import { Card } from 'react-bootstrap';
import { Dropdown } from "primereact/dropdown";
import { Toolbar } from 'primereact/toolbar';
import { getAniosFactura, getFacturasPorMesAnio, desactivaFactura}from '../api/facturaService'; 
import { getDocumentosPagoPorFactura }from '../api/pagosService'; 
import { format } from 'date-fns';
//import { formatDate } from 'date-fns/format';
import { es} from 'date-fns/locale'
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';


function MainOperaciones() {
const [facturas, setFacturas] = useState([]);
const dt = useRef(null);
const [visible, setVisible] = useState(false);
const [position, setPosition] = useState('center');
const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
const [pagos, setPagos] = useState([]);
const [pagosDialog, setPagosDialog] = useState(false);

const mesActualIndex = new Date().getMonth();

const [mesSeleccionado, setMesSeleccionado] = useState(mesActualIndex);
const [anios, setAnios] = useState([]);
const [anio, setAnio] = useState(null);

const [totalFactura, setTotalFactura] = useState(null);
const [totalPagado, setTotalPagado] = useState(null);
const [saldoPendiente, setSaldoPendiente] = useState(null);
const [mostrarPagos, setMostrarPagos] = useState(false);

const [deleteFacturaDialog, setDeleteFacturaDialog] = useState(false);
const hideDeleteFacturaDialog = () => setDeleteFacturaDialog(false);
 const toast = useRef(null);
const [filters, setFilters] = useState({
  global: { value: null, matchMode: FilterMatchMode.CONTAINS }
});

const [globalFilterValue, setGlobalFilterValue] = useState('');


const meses = Array.from({ length: 12 }, (_, i) =>
({
  label: new Date(0,i)
  .toLocaleString("es", { month: "long" })
  .toUpperCase(),
  value:i,
}));
meses.reverse();
// Cargar formas de pago al inicio
useEffect(() => {
    const fetchAniosFactura = async () =>{
     const data =await getAniosFactura();
    //console.log(fetchAniosFactura);
    setAnios(data);
     if (data.length > 0) {
      const maxAnio = Math.max(...data.map(a => a.value));
      setAnio(maxAnio);
    }};
    fetchAniosFactura();
}, []);

  const generarPDF = () => {
    console.log(facturaSeleccionada)
    const doc = new jsPDF();
      // const logoformato = empresa.logo.split(",")[0];
      //  console.log(logoformato);
      // const logoBase64 = empresa.logo.split(",")[1]; // quitar el "data:image/png;base64,"
      
      // doc.addImage(logoBase64, "PNG", 10, 10, 60, 30);
     

    const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

console.log("Ancho:", pageWidth, "Alto:", pageHeight);

    // Encabezado
    doc.setFontSize(10);
    doc.text("Lugar Expedicion", 150, 15);
   // doc.text(`${empresa.direccion.municipio} ${empresa.direccion.pais}`, 160, 20);
    
    doc.setFontSize(10);
    doc.text(`Folio:`, 150, 30);
    doc.text(`${facturaSeleccionada.folio}`, 160, 30);

    doc.text(`Fecha`, 150, 40);
    //doc.text(` ${facturaSeleccionada.fechaEmision.toISOString().split('T')[0]}`, 160, 45);
    
    doc.text(`Orden de compra: `, 150, 50);
    doc.text(` `, 160, 55);

    doc.text(`Tipo de cambio: `, 150, 60);
    doc.text(`${facturaSeleccionada.tipoCambio} `, 160, 65);
    


    // const body = datos.map(p => [
    //   p.nombre,
    //   p.cantidad,
    //   `$${p.precio.toFixed(2)}`,
    //   `$${(p.cantidad * p.precio).toFixed(2)}`
    // ]);

    // autoTable(doc, {
    //   startY: 70,
    //   head: [["Descripción", "Cantidad", "Precio Unitario", "Importe"]],
    //   body,
    // });
     // ======== PIE CON SUBTOTAL, IVA Y TOTAL ========
    const finalY = doc.lastAutoTable.finalY || 70;
    //const subtotal = datos.reduce((sum, p) => sum + p.cantidad * p.precio, 0);
    // const iva = subtotal * 0.16;
    // const total = subtotal + iva;

    // doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 150, finalY + 10);
    // doc.text(`IVA (16%): $${iva.toFixed(2)}`, 150, finalY + 16);
    // doc.setFontSize(14);
    // doc.text(`Total: $${total.toFixed(2)}`, 150, finalY + 24);
// Dibujar líneas verticales cada 10 mm
// for (let x = 10; x < pageWidth; x += 10) {
//   doc.line(x, 0, x, pageHeight);
//   doc.text(String(x), x, 5); // etiqueta con valor de X
// }

// // Dibujar líneas horizontales cada 10 mm
// for (let y = 10; y < pageHeight; y += 10) {
//   doc.line(0, y, pageWidth, y);
//   doc.text(String(y), 2, y); // etiqueta con valor de Y
// }
    // ======== GUARDAR PDF ========
  doc.save("factura.pdf");
  };

 const startContent = (
        <React.Fragment>
            <h5>Facturas procesadas</h5>
        </React.Fragment>
    );
  const endContent = (
        <React.Fragment>         
            {/* <Button label="Exportar CSV" icon="pi pi-file-excel" onClick={() => dt.current.exportCSV()} />  */}
            <Dropdown value={mesSeleccionado} options={meses} onChange={(e) => setMesSeleccionado(e.value)}  
            placeholder="Seleccione un mes" className="w-full md:w-14rem" />

            <Dropdown value={anio} options={anios} onChange={(e) => setAnio(e.value)}
            placeholder="Seleccione año" className="w-full md:w-14rem" />

        </React.Fragment>
    );
  const actionBodyTemplate = (rowData) => {//botones de accion
    return (
        <React.Fragment>
            <Button icon="pi pi-eye" rounded  className="mr-2" severity="success"   onClick={() => show(rowData)}/>
          
            <Button icon="pi pi-times" rounded  disabled={rowData.activo === 0}  severity="danger" onClick={() => confirmDeleteFactura(rowData)} />                                        
        </React.Fragment>
    );
  };
 
   
    const deleteFactura = async ()  => {
    try {
      //console.log(facturaSeleccionada);
        await desactivaFactura(facturaSeleccionada); // usa el _id de Mongo
        
        if (mesSeleccionado  !== null && anio !== null) {
          const data = await getFacturasPorMesAnio(mesSeleccionado , anio);          
            setFacturas(transformarFacturas(data|| []));
           }
        
        setDeleteFacturaDialog(false);
       
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Factura dasactivada', life: 3000 });
    } catch (error) {
        console.error('Error al  desactivar la factura:', error);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo desactivar la factura', life: 3000 });
    }}; 
     const show = (factura) => {
      setPosition("top");
      setFacturaSeleccionada(factura);       
      setVisible(true);
    };
 const deleteFacturaDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteFacturaDialog} />
            <Button label="Si" icon="pi pi-check" severity="danger" onClick={deleteFactura} />
        </React.Fragment>
    );
      useEffect(() => {
        const fetchData = async () => {
           if (mesSeleccionado  !== null && anio !== null) {
          const data = await getFacturasPorMesAnio(mesSeleccionado , anio);          
            setFacturas(transformarFacturas(data|| []));
           }
        };
    
        fetchData();
      }, [mesSeleccionado , anio]);

   const transformarFacturas = (facturas) => {
    //console.log(facturas);
    return facturas.map(f => ({
      facturaId: f.facturaId,
      folio: `${f.serie}-${f.folio}`,
      tipo: f.tipoFactura,
      nombreEmisor: f.datosReceptor?.[0]?.razonSocial || "N/A",
      ruc: f.datosReceptor?.[0]?.ruc || "N/A",
      fecha: new Date(f.fechaEmision),
      estado: f.status,
      total: f.totalPagar,
      _id:f._id,
      formaPago:f.formaPago,
      metodoPago:f.medioPago,
      //vigente:f.vigente,
      activo:f.activo
    }));
  };
const formatFecha = (rowData) => {
  if (!rowData.fecha) return '';
  return format(new Date(rowData.fecha), 'dd-MM-yyyy');
};
const abrirPagos = async () => {
  if (!facturaSeleccionada) return;

   // Si ya estamos mostrando los pagos, los ocultamos
  if (mostrarPagos) {
    setMostrarPagos(false);
    return;
  }

const datos = await getDocumentosPagoPorFactura(facturaSeleccionada._id);

const paguitos = Array.isArray(datos)
  ? datos.flatMap(pago => Array.isArray(pago.datosDocumento)
    ? pago.datosDocumento.map(doc => ({    
      numeroParcialidad: doc.numeroParcialidad,
      saldoAnterior: Number(doc.saldoAnterior || 0),
      saldoPagado: Number(doc.saldoPagado || 0),
    })):[]): [];

const totalP = paguitos.reduce((acc, p) => acc + p.saldoPagado ,0);
const totalF = Number(facturaSeleccionada.total  || 0);
const saldoPendiente = Math.max(0, totalF - totalP);

  setPagos(paguitos);
  setPagosDialog(true);
  setTotalFactura(totalF);
  setTotalPagado(totalP);
  setSaldoPendiente(saldoPendiente);

  setMostrarPagos(true);
};

const confirmDeleteFactura = (factura) => {
    setFacturaSeleccionada(factura);
    setDeleteFacturaDialog(true);
};
const statusBodyTemplate = (rowData) => {
  //console.log(rowData);
    const tipoMap = {
        1: { severity: "success", label: "Si" },
        0: { severity: "danger", label: "No" }
    };
//console.log(rowData.activo);
    const { severity, label } = tipoMap[rowData.activo] || { severity: "danger", label: "Desconocido" };

    return <Tag severity={severity} value={label} rounded />;
        };
const statusBodyEstado = (rowData) => {
  //console.log(rowData);
    const tipoMap = {
        PAGADA: { severity: "success", label: "PAGADA" ,icon :"pi pi-check" },
        PARCIAL: { severity: "contrast ", label: "PARCIAL", icon:"pi pi-exclamation-triangle" },
        ADEUDO: { severity: "warning", label: "ADEUDO" , icon:"pi pi-times"}
    };
//console.log(rowData.estado);
    const { severity, label, icon } = tipoMap[rowData.estado] || { severity: "danger", label: "Desconocido", icon:"pi pi-info-circle" };

    return <Tag icon={icon} severity={severity} value={label} rounded />;
        };

const onGlobalFilterChange = (e) => {
  const value = e.target.value;

  let _filters = { ...filters };
  _filters['global'].value = value;

  setFilters(_filters);
  setGlobalFilterValue(value);
};


    const renderHeader = () => {
      return (
          <div className="flex justify-content-end">
              <IconField iconPosition="left">
                  <InputIcon className="pi pi-search" />
                  <InputText value={globalFilterValue} 
                  onChange={onGlobalFilterChange} 
                  placeholder="Buscar ..." />
              </IconField>
          </div>
      );
  };     
  const header=renderHeader();

  return (
    <>
    <Toast ref={toast} />
      <h4>Consultas de facturas</h4>  
      <Card>
        <Toolbar  start={startContent}  end={endContent}  ></Toolbar>      
      </Card>
    <div>
      <Card>
      <DataTable  ref={dt} value={facturas} filters={filters} globalFilterFields={['ruc','nombreEmisor', 'folio']} filterDisplay="menu" header={header} paginator rows={15} responsiveLayout="scroll" stripedRows selectionMode="single"
      emptyMessage="No hay facturas para este mes y año">
        <Column field="facturaId" header="#" />
        <Column field="folio" header="Folio" />
        <Column field="tipo" header="Tipo" />
        <Column field="nombreEmisor" header="Nombre" />
        <Column field="ruc" header="RUC" />
        <Column field="fecha" header="Fecha" body={formatFecha}/>
        <Column field="activo"  header="Activo" body={statusBodyTemplate} />
        <Column field="total" header="Total" />
         <Column  header="Estado"  body={statusBodyEstado} />
        <Column  header="Accion"  body={actionBodyTemplate} />
      </DataTable>
      </Card>
    </div>

    <Dialog header={`Factura ${facturaSeleccionada ? facturaSeleccionada.folio : ""}`}
     visible={visible} style={{ width: '50vw' }} draggable={false} resizable={false}
     onHide={() =>{
      setVisible(false); // cierra el dialog
      setMostrarPagos(false);     // resetea la sección de pagos
      setPagos([]);               // opcional: limpiar tabla de pagos
     }}
      position={position}>
        {facturaSeleccionada && (
        <div>

        <div class="formgrid grid"> 
          <div class="field col-2 ">
            <label for="nombre" class=""><strong>Nombre:</strong> </label>
          </div>
          <div class="field col-10"> 
            <label class=""> {facturaSeleccionada.nombreEmisor} </label>
          </div>
        </div>

        <div class="formgrid grid"> 
          <div class="field col-2 ">
            <label for="receptor" class=""><strong>RUC:</strong> </label>
          </div>
          <div class="field col-10"> 
            <label class=""> {facturaSeleccionada.ruc} </label>
          </div>
        </div>
        
        <div class="formgrid grid"> 
          <div class="field col-2 ">
            <label for="fechaEmision" class=""><strong>Fecha de Emisión:</strong> </label>
          </div>
          <div class="field col-4"> 
            
            <label class="">  {format(new Date(facturaSeleccionada.fecha), "dd 'de' MMMM 'de' yyyy", {locale:es})} </label>
          </div>
          <div class="field col-1 ">
            <label for="fechaEmision" class=""><strong>Tipo:</strong> </label>
          </div>
          <div class="field col-5"> 
            <label class=""> {facturaSeleccionada.tipo || "No especificado"} </label>
          </div>
        </div>

          <div class="formgrid grid"> 
          <div class="field col-2 ">
            <label for="metodoPago" class=""><strong>Metodo de pago:</strong> </label>
          </div>
          <div class="field col-10"> 
            <label class=""> {facturaSeleccionada.formaPago || "No especificado"} </label>
          </div>
        </div>
        
        </div>  
        //<label class="">  {format(new Date(facturaSeleccionada.fecha), "dd-MM-yyyy")} </label>  
  )}
  <div class="field grid">
    <div class="field col">
      <Button  label="Ver Pagos" icon="pi pi-dollar" onClick={abrirPagos} className="p-button-success" />
    </div>
    <div class="field col">
       {/* <Button label="Descargar PDF" icon="pi pi-file-pdf" severity="info" onClick={generarPDF} /> */}
    </div>
  </div>

  {mostrarPagos && (
  <div style={{ marginTop: "1rem" }}>
    <h5>Pagos de la Factura</h5>
    <DataTable value={pagos} responsiveLayout="scroll" emptyMessage="No hay pagos registrados">
      <Column field="numeroParcialidad" header="Parcial" />
      <Column field="saldoAnterior" header="Saldo" />
      <Column field="saldoPagado" header="Pagado" />
    </DataTable>

    <div style={{ marginTop: "1rem", textAlign: "right" }}>
      <p><strong>Total Factura:</strong> {Number(totalFactura || 0 ).toFixed(2)}</p>
      <p><strong>Pagado:</strong> {Number(totalPagado || 0 ).toFixed(2)}</p>
      <p><strong>Restante:</strong> {Number(saldoPendiente|| 0 ).toFixed(2)}</p>
    </div>
  </div>
)}

  </Dialog>
    <Dialog visible={deleteFacturaDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirmar" modal footer={deleteFacturaDialogFooter} onHide={hideDeleteFacturaDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {facturaSeleccionada && (
                        <span>
                            ¿Desea dar de baja la factura <b>{facturaSeleccionada.folio}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
    </>
  );
}

export default MainOperaciones; 
